import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "brand-text font-weight-light" }, "AdminLTE 3", -1)
const _hoisted_2 = { class: "sidebar" }
const _hoisted_3 = { class: "user-panel mt-3 pb-3 mb-3 d-flex" }
const _hoisted_4 = { class: "image" }
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { class: "mt-2" }
const _hoisted_7 = {
  class: "nav nav-pills nav-sidebar flex-column",
  "data-widget": "treeview",
  role: "menu",
  "data-accordion": "false"
}

export function render(_ctx, _cache) {
  const _component_pf_image = _resolveComponent("pf-image")
  const _component_router_link = _resolveComponent("router-link")
  const _component_app_menu_item = _resolveComponent("app-menu-item")

  return (_openBlock(), _createElementBlock("aside", {
    class: _normalizeClass(["main-sidebar elevation-4", _ctx.sidebarSkin])
  }, [
    _createVNode(_component_router_link, {
      to: "/",
      class: "brand-link"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_pf_image, {
          src: require('@/assets/img/logo.png'),
          alt: "AdminLTE Logo",
          class: "brand-image",
          height: "33",
          width: "33",
          rounded: "",
          style: {"opacity":"0.8"}
        }, null, 8, ["src"]),
        _hoisted_1
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_pf_image, {
            src: _ctx.user && _ctx.user.picture,
            fallbackSrc: require('@/assets/img/default-profile.png'),
            class: "img-circle",
            alt: "User Image",
            width: "34",
            height: "34",
            rounded: ""
          }, null, 8, ["src", "fallbackSrc"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: "/profile",
            class: "d-block"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.user && _ctx.user.email), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("nav", _hoisted_6, [
        _createElementVNode("ul", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (item) => {
            return (_openBlock(), _createBlock(_component_app_menu_item, { menuItem: item }, null, 8, ["menuItem"]))
          }), 256))
        ])
      ])
    ])
  ], 2))
}